import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  announcements: [],
  loading: false,
  error: null,
};
const BASE_URL = "https://api.aweioio.com/api/announcements";

// Fetch announcements for a business
export const fetchAnnouncements = createAsyncThunk(
  "announcements/fetchAnnouncements",
  async (businessId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.aweioio.com/api/announcements/${businessId}`
      );
      return response.data.announcements; // Return the announcements
    } catch (error) {
      console.error(
        "Error fetching announcements:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create an announcement
export const createAnnouncement = createAsyncThunk(
  "announcements/createAnnouncement",
  async ({ title, description, businessId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.aweioio.com/api/announcements",
        {
          title,
          description,
          businessId,
        }
      );
      return response.data.announcement; // Return the created announcement
    } catch (error) {
      console.error(
        "Error creating announcement:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateAnnouncement = createAsyncThunk(
  "announcements/update",
  async ({ announcementId, title, description }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/${announcementId}`, { title, description });
      return res.data.announcement;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteAnnouncement = createAsyncThunk(
  "announcements/delete",
  async ({ announcementId, businessId }, { rejectWithValue }) => {
    console.log(announcementId,"annnn")
    try {
      await axios.delete(`${BASE_URL}/${announcementId}/${businessId}`);
      return announcementId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
const announcementsSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.announcements = action.payload;
      })
      .addCase(fetchAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createAnnouncement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAnnouncement.fulfilled, (state, action) => {
        state.loading = false;
        state.announcements.push(action.payload); // Add the new announcement
      })
      .addCase(createAnnouncement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(updateAnnouncement.fulfilled, (state, action) => {
        const index = state.announcements.findIndex(a => a._id === action.payload._id);
        if (index !== -1) state.announcements[index] = action.payload;
      })
      .addCase(deleteAnnouncement.fulfilled, (state, action) => {
        state.announcements = state.announcements.filter(a => a._id !== action.payload);
      });
  },
});

export default announcementsSlice.reducer;
